/* eslint-disable react/prop-types, prefer-template */
import React from 'react';
import { StyleSheet, css } from 'aphrodite';
import classnames from 'classnames';
import { ROW_MAX_WIDTH } from 'es6/core/styles/sizes';

export default function Row({ children, flexible = false }) {
  return (
    <div className={classnames(css(styles.row), css(flexible ? styles.flexible : styles.fixed))}>
      {children}
    </div>
  );
}

const styles = StyleSheet.create({
  row: {
    display: 'flex',
    flexFlow: 'row wrap',
    justifyContent: 'space-between',
    marginLeft: 'auto',
    marginRight: 'auto',
  },
  flexible: {
    maxWidth: ROW_MAX_WIDTH + 'px',
  },
  fixed: {
    width: ROW_MAX_WIDTH + 'px',
  },
});
